import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Theme from "./components/Styles/Theme/Theme";

// Pages
import Home from "./pages/Home";
import Signin from "./pages/Signin";
import WebApplication from "./pages/WebApplication";
import MobileApplication from "./pages/MobileApplication";
import Uiux from "./pages/Uiux";
import WordpressDesign from "./pages/WordpressDesign";
import Seo from "./pages/Seo";
import SocialMedia from "./pages/SocialMedia";
import Aboutus from "./pages/Aboutus";
import Portfolio from "./pages/Portfolio";
import Contactus from "./pages/Contactus";

import WepAppPricing from "./pages/WepAppPricing";
import MobileAppPricing from "./pages/MobileAppPricing";
import UiuxPricing from "./pages/UiuxPricing";
import SeoPricing from "./pages/SeoPricing";
import WordpressPricing from "./pages/WordpressPricing";

import Dental from "./pages/Dental";
import Daycare from "./pages/Daycare";
import Cosmetic from "./pages/Cosmetic";
import GymFitness from "./pages/GymFitness";
import RestaurantCafe from "./pages/RestaurantCafe";

import P404 from "./pages/P404";
import Test from "./pages/Test";
import LanguageWrapper from "./components/LanguageWrapper";
import { slugs } from "./config/slugs";

/* ---------------- Language Wrapper ---------------- */

function LanguageLayout() {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    const supportedLanguages = ["en", "fa"];

    if (!supportedLanguages.includes(lang)) {
      i18n.changeLanguage("en");
      return;
    }

    i18n.changeLanguage(lang);

    const isFa = lang === "fa";
    document.documentElement.dir = isFa ? "rtl" : "ltr";
    document.documentElement.lang = isFa ? "fa" : "en";
  }, [lang, i18n]);

  return <Outlet />;
}

/* ---------------- App ---------------- */

function App() {
  return (
    <BrowserRouter>
      <Theme>
        <Header />

        <main>
          <Routes>
            {/* Redirect root to default language */}
            <Route path="/" element={<Navigate to="/en" replace />} />

            {/* Language based routes */}
            <Route path="/:lang" element={<LanguageWrapper />}>
              <Route index element={<Home />} />

              {/* Signin */}
              <Route path={slugs.signin.en} element={<Signin />} />
              <Route path={slugs.signin.fa} element={<Signin />} />

              {/* Services */}
              <Route path={slugs.webApplication.en} element={<WebApplication />} />
              <Route path={slugs.webApplication.fa} element={<WebApplication />} />

              <Route path={slugs.mobileApplication.en} element={<MobileApplication />} />
              <Route path={slugs.mobileApplication.fa} element={<MobileApplication />} />

              <Route path={slugs.uiux.en} element={<Uiux />} />
              <Route path={slugs.uiux.fa} element={<Uiux />} />

              <Route path={slugs.wordpress.en} element={<WordpressDesign />} />
              <Route path={slugs.wordpress.fa} element={<WordpressDesign />} />

              <Route path={slugs.seo.en} element={<Seo />} />
              <Route path={slugs.seo.fa} element={<Seo />} />

              <Route path={slugs.social.en} element={<SocialMedia />} />
              <Route path={slugs.social.fa} element={<SocialMedia />} />

              {/* About & Contact */}
              <Route path={slugs.about.en} element={<Aboutus />} />
              <Route path={slugs.about.fa} element={<Aboutus />} />

              {/* Portfolio */}
              <Route path={slugs.portfolio.en} element={<Portfolio />} />
              <Route path={slugs.portfolio.fa} element={<Portfolio />} />

              <Route path={slugs.contact.en} element={<Contactus />} />
              <Route path={slugs.contact.fa} element={<Contactus />} />

              {/* Pricing */}
              <Route path={slugs.webAppPricing.en} element={<WepAppPricing />} />
              <Route path={slugs.webAppPricing.fa} element={<WepAppPricing />} />

              <Route path={slugs.mobileAppPricing.en} element={<MobileAppPricing />} />
              <Route path={slugs.mobileAppPricing.fa} element={<MobileAppPricing />} />

              <Route path={slugs.uiuxPricing.en} element={<UiuxPricing />} />
              <Route path={slugs.uiuxPricing.fa} element={<UiuxPricing />} />

              <Route path={slugs.wordpressPricing.en} element={<WordpressPricing />} />
              <Route path={slugs.wordpressPricing.fa} element={<WordpressPricing />} />

              <Route path={slugs.seoPricing.en} element={<SeoPricing />} />
              <Route path={slugs.seoPricing.fa} element={<SeoPricing />} />

              {/* Clients */}
              <Route path={slugs.dental.en} element={<Dental />} />
              <Route path={slugs.dental.fa} element={<Dental />} />

              <Route path={slugs.daycare.en} element={<Daycare />} />
              <Route path={slugs.daycare.fa} element={<Daycare />} />

              <Route path={slugs.cosmetic.en} element={<Cosmetic />} />
              <Route path={slugs.cosmetic.fa} element={<Cosmetic />} />

              <Route path={slugs.gymFitness.en} element={<GymFitness />} />
              <Route path={slugs.gymFitness.fa} element={<GymFitness />} />

              <Route path={slugs.restaurantCafe.en} element={<RestaurantCafe />} />
              <Route path={slugs.restaurantCafe.fa} element={<RestaurantCafe />} />

            </Route>

            {/* 404 */}
            <Route path="*" element={<P404 />} />
          </Routes>
        </main>

        <Footer />
      </Theme>
    </BrowserRouter>
  );
}

export default App;